"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellDate = function CellDate(props) {
  var data = props.data,
      header = props.header,
      handleClick = props.handleClick,
      headerText = props.headerText,
      sortOrder = props.sortOrder,
      sortable = props.sortable,
      width = props.width,
      sorted = props.sorted,
      _props$dateOptions = props.dateOptions,
      dateOptions = _props$dateOptions === void 0 ? {
    "short": true
  } : _props$dateOptions;

  if (!header && !(0, _Utils.validateDate)(data)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    onClick: handleClick,
    width: width,
    sortable: sortable,
    sortOrder: sortOrder,
    sorted: sorted
  }, headerText || data) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    width: width,
    sorted: sorted
  }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    color: "textLightGrey"
  }, (0, _Utils.formatDate)(data, dateOptions)));
};

var _default = CellDate;
exports["default"] = _default;

//# sourceMappingURL=CellDate.js.map